import {FACTIONS} from "../../../constants/factions";

export const WIZARDS_QUOTES = [{
  quote: 'Пока вы копите золото, мы коптим небо заклинаниями, которые превратят ваше золото в свинец',
  author: 'Авл Корруптус, архимаг Башни Голодного Ветра',
  factionId: FACTIONS.WIZARDS
}, {
  quote: 'Хороший маг заканчивает бой до того, как начался ближний. Мудрый маг — до того, как началась война',
  author: 'Клодия Виа, куратор магической инфраструктуры Семи Башен',
  factionId: FACTIONS.WIZARDS
}, {
  quote: 'Лучшее заклинание — то, о котором враг не знает. А лучшее из лучших — то, о котором он узнал, когда уже поздно',
  author: 'Секст Утилитарий, ректор университета Практической магии в Хордалеосе',
  factionId: FACTIONS.WIZARDS
}, {
  quote: 'Иллюзия легиона стоит дешевле настоящего легиона',
  author: 'Солюций Фантазм, маг-призыватель Башня Ложных Знамен',
  factionId: FACTIONS.WIZARDS
}, {
  quote: 'Лучшая защита от врага — чтобы у врага не было денег на мечи',
  author: 'Квинт Нумис, маг монетного проклятия Третьей Башни',
  factionId: FACTIONS.WIZARDS
}, {
  quote: 'Превращение свинца в золото — детская задача по сравнению с превращением врага в союзника',
  author: 'Валерия Фульгура, маг-легатесса Молненосной Башни',
  factionId: FACTIONS.WIZARDS
}]